














import {Component, Mixins} from 'vue-mixin-decorator';
import {Inject} from 'inversify-props';

import {LoraForwarder} from '@/model/lora/LoraForwarder';

import {ILoraForwardersService} from '@/services/lora/ILoraForwarders.service';

import LoraHardwareWidget from '@/components/Lora/LoraHardwareWidget.vue';
import LoraForwarderRunStatusWidget from '@/components/Lora/Forwarder/LoraForwarderRunStatusWidget.vue';
import LoraForwarderStatus from '@/components/Lora/Forwarder/LoraForwarderStatus.vue';
import {Notify} from '@/utils/Notify';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {LoraForwarderStatus, LoraForwarderRunStatusWidget, LoraHardwareWidget},
})
export default class LoraStatusPage extends Mixins<BaseComponent>(BaseComponent) {
  @Inject(Symbol.for('ILoraForwardersService'))
  private loraForwarderService!: ILoraForwardersService;

  private forwarder: LoraForwarder | null = null;

  private async mounted() {
    await this.refresh();
  }

  private async refresh() {
    this.setLoading();
    try {
      this.forwarder = await this.loraForwarderService.getActive();
      this.logger.debug(`Active forwarder fetched`, this.forwarder);
    } catch (error) {
      Notify.Error(this.logger, `Could not get LoRa status from the gateway`, error);
    } finally {
      this.setLoaded();
    }
  }
}
